export default __webpack_public_path__ + "static/media/nfty-connect.71a6654b.jpg";